var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgNeuro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 774,
    viewBox: "0 0 1440 774",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_538_3524)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_3524",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 774
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V773.965C1440 773.965 1003.75 774.043 720.5 773.965C438.023 773.888 0 773.965 0 773.965V0Z",
    fill: "#F4F1FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_3524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.238 -518.528C369.86 -543.089 400.002 -552.768 424.563 -540.147L1616.4 72.3261C1640.96 84.9477 1650.64 115.09 1638.02 139.651L1429.64 545.139C1417.02 569.698 1387.09 579.483 1362.53 566.865C1253.67 510.936 967.201 363.754 766.847 260.744C566.947 157.968 279.416 10.2383 170.286 -45.8285C145.721 -58.4487 136.245 -88.4883 148.868 -113.051L357.238 -518.528Z",
    fill: "#055094",
    fillOpacity: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.31 218.472C1031.94 193.911 1062.08 184.232 1086.64 196.853L1693.83 508.88C1718.39 521.502 1728.07 551.644 1715.44 576.205L1481.81 1030.85C1469.19 1055.4 1439.08 1065.1 1414.52 1052.48C1345.22 1016.89 1209.19 947.005 1111.14 896.565C1013.29 846.232 876.785 776.106 807.296 740.412C782.728 727.793 773.066 697.657 785.69 673.091L1019.31 218.472Z",
    fill: "#055094",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-411.504 366.472C-398.882 341.911 -368.74 332.232 -344.179 344.853L263.008 656.88C287.569 669.502 297.248 699.644 284.626 724.205L50.9906 1178.85C38.3713 1203.4 8.26449 1213.1 -16.2944 1200.48C-85.5959 1164.89 -221.624 1095 -319.68 1044.57C-417.53 994.232 -554.033 924.106 -623.522 888.412C-648.09 875.793 -657.752 845.657 -645.128 821.091L-411.504 366.472Z",
    fill: "#055094",
    fillOpacity: 0.13
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_538_3524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 774,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNeuro);
export default __webpack_public_path__ + "static/media/bg-neuro.67ca8c8195ddf6bf7c9dd3e65edb52bf.svg";
export { ForwardRef as ReactComponent };